import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.

root.render(
  <React.StrictMode>
    <ChakraProvider>
      <Router> {/* Wrap App with Router */}
        <App />
      </Router>
    </ChakraProvider>
  </React.StrictMode>
);
